<template lang="pug">
  .main
    h4 Session
      button(@click="startSession" :class="{disabled:!allowStartSession}") refresh
    .new-session
      .session-fields
        input(placeholder="ip" v-model="sIp" @keyup.enter="startSession")
        input(placeholder="interfaceId" v-model="sInterfaceId" @keyup.enter="startSession")
        input(placeholder="password" v-model="sPass" @keyup.enter="startSession")
      .session
        pre {{ session }}
    h4 Request
    .input
      .method
        select(v-model="method" @keyup.enter="send")
          option(value="get") GET
          option(value="put") PUT
          option(value="post") POST
          option(value="head") HEAD
      .ip
        span http://
        input(v-model="ip" placeholder="ip:port" @keyup.enter="send")
      .endpoint
        span /
        input(v-model="endpoint" placeholder="endpoint" @keyup.enter="send")
      .button
        button(@click="send" :class="{disabled:!allowSend}") send
    .body
      textarea(v-model="body" rows="10" placeholder="body" onkeydown="if(event.keyCode===9){var v=this.value,s=this.selectionStart,e=this.selectionEnd;this.value=v.substring(0, s)+'\t'+v.substring(e);this.selectionStart=this.selectionEnd=s+1;return false;}")
    .request-headers
      textarea(v-model="reqHeaders" ref="reqHeaders" @keyup.enter="send" rows="3" placeholder="body" onkeydown="if(event.keyCode===9){var v=this.value,s=this.selectionStart,e=this.selectionEnd;this.value=v.substring(0, s)+'\t'+v.substring(e);this.selectionStart=this.selectionEnd=s+1;return false;}")
    .status(v-if="status")
      h4 Status
      pre {{status}}
    .headers(v-if="headers")
      h4 Headers
      pre {{headers}}
    .resonse(v-if="response")
      h4 Response
      pre {{response}}
    .error(v-if="error")
      h4 Error
      pre {{error}}
</template>


<script>
import axios from 'axios'
import secure from './secure'

export default {
  name: 'app',
  data () {
    return {
      sIp: '',
      sInterfaceId: '',
      sPass: 'password',
      method: 'get',
      ip: '',
      endpoint: '',
      body: '',
      reqHeaders:`{
  "Content-Type": "text/plain"
}`,
      response: false,
      status: false,
      headers: false,
      error: false,
      session: false
    }
  },
  watch: {
    session () {
      console.log('[main] SESSION OBJ:', this.session)
      if (this.session) {
        let h = {}
        try {
          h = JSON.parse()
        } catch (e) {
          h = { 'Content-Type': 'text/plain' }
        }
        h['X-Session-Id'] = this.session.sessionId
        if (this.session.counter) h['X-Session-Count'] = this.session.counter()
        const rows = Object.keys(h).length + 2
        this.$refs.reqHeaders.rows = rows
        this.reqHeaders = JSON.stringify(h, null, 2)
      }
    },
    sIp () {
      this.ip = this.sIp
    },
    ip () {
      this.sIp = this.ip
    }
  },
  computed: {
    allowStartSession () {
      return (this.sIp && this.sInterfaceId && this.sPass)
    },
    allowSend () {
      return (this.method && this.ip)
    }
  },
  methods: {
    startSession () {
      if (this.sIp && this.sInterfaceId && this.sPass) {
        this.session = 'loading...'
        secure.getApiSession (this.sIp, this.sInterfaceId, this.sPass)
          .then((session) => {
            this.session = session
          })
          .catch((error) => {
            this.session = error.toString()
          })
      }
    },
    send() {
      if (this.method && this.ip) {
        this.response = false
        this.status = false
        this.headers = false
        this.error = false
        const req = {
          method: this.method,
          url: 'http://' + this.ip + '/' + this.endpoint,
        }
        if (this.body) {
          if (this.session) {
            let cipher = ''
            try {
              cipher = this.session.cipher(JSON.parse(this.body))
            } catch (e) {
              console.log('[main] CATCH ENCRYPT JSON.PARSE(body), body:', this.body)
              console.log('   |-> Error:', e)
              cipher = this.session.cipher(this.body, true)
            }
            console.log('[main] ENCRYPTED DATA:', cipher)
            req.data = cipher
          } else {
            req.data = this.body
            try {
              req.data = JSON.stringify(JSON.parse(this.body))
            } catch (e) {
              req.data = this.body
            }
          }
        }
        try {
          req.headers = JSON.parse(this.reqHeaders)
        } catch (e) {
          req.headers = { 'Content-Type': 'text/plain' }
        }
        // if (this.session) {
        //   req.headers['X-Session-Id'] = this.session.sessionId
        //   req.headers['X-Session-Count'] = this.session.counter()
        // }
        console.log('[main] AXIOS REQUEST:', req)
        axios(req)
          .then((response) => {
            console.log('[main] AXIOS RESPONSE:', response)
            this.error = false
            if (response.data) {
              try {
                const data = this.session.data(response.data)
                console.log('[main] DECRYPTED DATA', data)
                if (data) {
                  this.response = data
                  this.session.increase()
                  this.session.count = this.session.getCount()
                  this.session = Object.assign({}, this.session)
                } else {
                  this.response = response.data
                }
              } catch (e) {
                this.response = response.data
              }
            }
            if (response.status) this.status = response.status + ' (' + response.config.url + ')'
            if (response.headers) {
              let n = 0
              for (const header in response.headers) {
                if (n > 0) this.headers += '\n'
                this.headers = header + ': ' + response.headers[header]
                n ++
              }
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status) this.status = error.config.url + '; ' + error.response.status
              if (error.response.data) this.response = error.response.data
              if (error.response.headers) this.headers = error.response.headers
              this.error = error.response.statusText
            } else {
              this.error = error.toString()
            }
          })
      }
    }
  }
}
</script>

<style lang="stylus">

  $el-padding = 10px 15px

  html, body
    font-size 18px
    font-family Arial, Helvetica, sans-serif
    margin 20px 20px 40px 20px

  *
    margin 0
    padding 0
    box-sizing: border-box;

  .main
    margin auto
    width 100%
    min-width 700px
    max-width 900px

  input, textarea
    border solid 1px #bbb
    font-family: 'Courier New', Courier, monospace
    padding $el-padding
    font-size 15px
  
  input, select, textarea
    width 100%
  
  textarea, pre
    tab-size 2
    padding 12px

  button
    width 100%
    border solid 1px #bbb
    background none
    padding $el-padding
    text-transform uppercase
    font-size 15px
    letter-spacing 1px
    color #888
    border-radius 5px
    &:not(.disabled)
      cursor pointer
      &:hover
        background #bbb
        color #fff
    &.disabled
      color #ccc
      border-color #ccc

  h4
    margin-top 10px
    display flex
    align-items center
    button
      display inline-block
      width auto
      font-size 10px
      padding 5px 8px
      margin-left 10px

  .input
    display flex
    align-items center
    margin -5px
    > *
      margin 5px
      display block
    .method
      flex 1
    .ip
      flex 4
      display flex
      align-items center
      span
        font-family: 'Courier New', Courier, monospace
        padding $el-padding
        font-size 15px
        flex 1
      input
        flex 10
    .endpoint
      flex 5
      display flex
      align-items center
      span
        padding-right 10px
    .button
      flex 1

  .body
    margin-top 10px
    margin-bottom 10px
    line-height 0

  .request-headers
    margin-bottom 20px

  .resonse, .status, .headers, .error, .session
    pre
      margin 0
      margin-top 5px
      font-size 12px
      padding 12px
      background #222
      color #fff
      overflow-x scroll
      overflow-y auto
  .error pre
    background none
    color red
    border solid 1px red

  .new-session
    margin-top 10px
    margin-bottom 20px
    display flex
    align-items stretch
    .session-fields
      flex 1
      min-width 100px
      input
        margin-bottom 5px
        &:last-child
          margin-bottom 0
    .session
      flex 3
      overflow-y auto
      overflow-x scroll
      pre
        max-width 100%
        margin 0 0 0 10px
        min-height 100%


</style>


// WEBPACK FOOTER //
// src/App.vue